/**
 * Verti DEU PL API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Price } from './price';
import { PrivateLiabilityDeductible } from './privateLiabilityDeductible';
import { CoInsuredPerson } from './coInsuredPerson';

/**
 * Represents a private liability insurance.   (german: Privathaftpflicht)   (bipro-versicherung-haftpflicht::Privat)
 */
export interface PrivateLiabilityInsurance {
  /**
   * Technical discriminator for the concrete elementary product type.
   */
  productType: string;
  /**
   * Calculated prices for this product.  Currency is always euro and cent.   (german: Beitrag) (bipro-produktmodell::Beitrag)
   */
  prices?: Array<Price>;
  deductible: PrivateLiabilityDeductible;
  /**
   * Reference to partners, which have the role *co-insured person*.   (german: mitversicherte Person)   (bipro-versicherung-haftpflicht::MitversichertePerson)
   */
  coInsuredPersons?: Array<CoInsuredPerson>;
}
export namespace PrivateLiabilityInsurance {}
